<template>
  <div class="course-content">
    <weui-group title="请您按照自己所需时段提出申请，教练统一进行协调">
      <weui-cell @click="selectDate">{{ formatDate(draft.date) }}</weui-cell>
      <weui-cell text="开始时间" :tips="formatTime(draft.start_time) || '--:--'" @click="selectStartTime" />
      <weui-cell text="结束时间" :tips="formatTime(draft.end_time) || '--:--'" @click="selectEndTime" />
    </weui-group>
    <weui-group>
      <weui-button-cell @click="submit">提出课程申请</weui-button-cell>
    </weui-group>
  </div>
</template>

<script>
import weui from 'weui.js';

import { WeuiGroup, WeuiCell, WeuiButtonCell, WeuiSwitch } from '@/components/weui';
import { ROUTE_COURSE_CREATE_CREATED } from '@/router/names';
import mixinFormatters from '@/mixins/formatters';
import mixinUniqid from '@/mixins/uniqid';
import datetimeUtils from '@/utils/datetime';

import mixinDraft from './draft.mixin';

export default {
    methods: {
        selectDate() {
            const vm = this;
            const firstDay = datetimeUtils.getFirstDay();
            const day = new Date(this.draft.date);
            const confirmDate = (result) => {
                const selected = new Date(result[0].value, result[1].value - 1, result[2].value);
                const newDate = vm.formatISODate(selected);
                if (vm.draft.date !== newDate) {
                    vm.fillDraft({
                        date: newDate,
                    });
                }
            };
            weui.datePicker({
                id: this.uniqid(),
                start: firstDay,
                end: new Date(firstDay.getFullYear(), firstDay.getMonth() + 3, firstDay.getDate()),
                defaultValue: [day.getFullYear(), day.getMonth() + 1, day.getDate()],
                onConfirm: confirmDate,
            });
        },
        buildTimeOptions(startTime, endTime) {
            const startTs = datetimeUtils.fromTimeString(startTime);
            const endTs = datetimeUtils.fromTimeString(endTime);

            const timeOptions = [];
            for (let ptr = startTs; ptr <= endTs; ptr += 1800) {
                const ptrString = datetimeUtils.toTimeString(ptr);
                timeOptions.push({
                    label: this.formatTime(ptrString),
                    value: ptrString,
                });
            }

            return timeOptions;
        },
        selectStartTime() {
            const vm = this;
            const startTimeOptions = this.buildTimeOptions('00:00:00', '23:30:00');
            const defaultStartTime = this.draft.start_time || startTimeOptions[0].value;
            weui.picker(startTimeOptions, {
                id: this.uniqid(),
                defaultValue: [defaultStartTime],
                onConfirm: (result) => {
                    if (vm.draft.start_time !== result[0].value) {
                        vm.fillDraft({
                            start_time: result[0].value,
                            end_time: datetimeUtils.getNextHour(result[0].value),
                        });
                    }
                },
            });
        },
        selectEndTime() {
            const vm = this;
            const endTimeOptions = this.buildTimeOptions(this.draft.start_time || '00:30:00', '24:00:00');
            if (endTimeOptions.length === 0) {
                return;
            }
            const defaultEndTime = this.draft.end_time || endTimeOptions[0].value;
            weui.picker(endTimeOptions, {
                id: this.uniqid(),
                defaultValue: [defaultEndTime],
                onConfirm: (result) => {
                    vm.fillDraft({
                        end_time: result[0].value,
                    });
                },
            });
        },
        submit() {
            this.createDraft(this.draft)
                .then(() => {
                    this.$router.push({
                        name: ROUTE_COURSE_CREATE_CREATED,
                        params: {
                            id: this.created.id,
                        },
                    });
                });
        },
    },
    mixins: [
        mixinDraft,
        mixinFormatters,
        mixinUniqid,
    ],
    components: {
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
        WeuiSwitch,
    },
};
</script>



// WEBPACK FOOTER //
// src/components/course/Content.vue